<template>
  <div
    class="income-indicators"
    id="income-indicators"
    :style="{ height: HEIGHT + 'px' }"
  >
    <div class="homepage-title">
      <el-tooltip placement="bottom" :open-delay="delay" popper-class="atooltip">
        <div slot="content">损耗率=(电表消耗电量-充电量)/电表损耗电量<br/>使用率=一天内充电时长总和(桩数*24小时)<br/>利用率=一天内订单充电量/(庄总功率*24小时)</div>
        <span class="title-n">运行状态</span>
      </el-tooltip>
      <div style="flex-grow: 3"></div>
      <div class="right-btn">
        <span :class="[active == 1 ? 'active' : '']" @click="dateClick(1)"
          >日</span
        >
        <span>/</span>
        <span :class="[active == 2 ? 'active' : '']" @click="dateClick(2)"
          >月</span
        >
      </div>
    </div>
    <div style="width: 100%; height: 100%" id="indicators-echarts"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import { type } from "os";
export default {
  data() {
    return {
      delay:1000,
      HEIGHT: "",
      width: "",
      active: 1,
      list: {
        day: [
          {
            date: "03-01",
            sum: 400,
          },
          {
            date: "03-02",
            sum: 250,
          },
          {
            date: "03-03",
            sum: 400,
          },
          {
            date: "03-04",
            sum: 450,
          },
          {
            date: "03-05",
            sum: 320,
          },
          {
            date: "03-06",
            sum: 400,
          },
        ],
        month: [
          {
            date: "01-01",
            sum: 0,
          },
          {
            date: "02-01",
            sum: 0,
          },
          {
            date: "03-01",
            sum: 0,
          },
          {
            date: "04-01",
            sum: 0,
          },
          {
            date: "05-01",
            sum: 0,
          },
          {
            date: "06-01",
            sum: 0,
          },
        ],
      },
    };
  },
  mounted() {
    let o = document.getElementById("income-indicators");
    this.width = o.clientWidth || o.offsetWidth;
    // this.HEIGHT = this.width/1.438;
    this.HEIGHT = this.width / 1.63847;

    this.$nextTick(function () {
      if (localStorage.getItem("token")) {
        this.getEchartData();
      }

      // this.getEchartData();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
  destroyed() {
    window.onresize = null;
  },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    isChangeMsg(val) {
      let echart = echarts.init(document.getElementById("indicators-echarts"));
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        setTimeout(function () {
          echart.resize();
        }, 0);
      }, 100);
    },
  },
  methods: {
    getEchartData(data) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getDayMonthRunningStatus",
      };
      this.$api({
        method: "post",
        url: "/api.php/Overview/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          this.$store.commit("getDayMonthRunningStatus", su);
          if (su.data.code == 1) {
            this.list = su.data.list;
            this.drawChart(this.list.day);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    calMax(arr) {
      // console.log(arr);
      for (let j in arr) {
        arr[j] = Number(arr[j]);
        if (arr[j] < 0) {
          arr[j] = 0;
        }
      }
      var max = arr[0];
      for (var i = 1; i < arr.length; i++) {
        // 求出一组数组中的最大值
        if (max < arr[i]) {
          max = arr[i];
        }
      }
      var maxint = Math.ceil(max / 10); // 向上取整
      var maxval = maxint * 10; // 最终设置的最大值
      var min = arr[0];
      return maxval; // 输出最大值
    },
    calMaxTow(arr1, arr2) {
      for (let j in arr1) {
        arr1[j] = Number(arr1[j]);
      }
      for (let j in arr2) {
        arr2[j] = Number(arr2[j]);
      }
      var max1 = arr1[0];
      for (var i = 1; i < arr1.length; i++) {
        // 求出一组数组中的最大值
        if (max1 < arr1[i]) {
          max1 = arr1[i];
        }
      }
      var max2 = arr2[0];
      for (var i = 1; i < arr2.length; i++) {
        // 求出一组数组中的最大值
        if (max2 < arr2[i]) {
          max2 = arr2[i];
        }
      }
      let max = 0;
      if (max1 > max2) {
        max = max1;
      } else {
        max = max2;
      }
      var maxint = Math.ceil(max / 10); // 向上取整
      var maxval = maxint * 10; // 最终设置的最大值
      return maxval; // 输出最大值
    },
    drawChart(data) {
      clearInterval(this.timer);
      clearInterval(this.timer1);
      var series = JSON.parse(JSON.stringify(data));
      var attrition_rate = []; //损耗率
      var date = [];
      var usage_rate = []; //使用率
      var utilization_rate = []; //利用率
      for (let i = 0; i < series.length; i++) {
        attrition_rate.push(series[i].attrition_rate);
        date.push(series[i].date);
        usage_rate.push(series[i].usage_rate);
        utilization_rate.push(series[i].utilization_rate);
      }
      // console.log(attrition_rate);
      // attrition_rate = ["0.00", "0.00", "0.00", "0.00", "1.00", "-1.03", "-1.02"];

      var maxappreg = this.calMax(attrition_rate); //损耗率
      var maxactive = this.calMaxTow(utilization_rate, usage_rate); //利用率
      var interval_left = Math.ceil(maxappreg / 5); //左轴间隔
      var interval_right = Math.ceil(maxactive / 5); //右轴间隔
      // console.log(maxappreg);

      let echart = echarts.init(document.getElementById("indicators-echarts"));
      var option = {
        color: ["#F5EE1A", "#4B8EFF", "#00CD56"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            // return
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "损耗率") {
                txtCon +=
                  arr[i].marker +
                  "损耗率" +
                  " : " +
                  arr[i].data +
                  " %" +
                  "<br/>";
              } else if (arr[i].seriesName == "使用率") {
                txtCon +=
                  arr[i].marker +
                  "使用率" +
                  " : " +
                  arr[i].data +
                  " %" +
                  "<br/>";
              } else if (arr[i].seriesName == "利用率") {
                txtCon +=
                  arr[i].marker +
                  "利用率" +
                  " : " +
                  arr[i].data +
                  " %" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          // orient: 'vertical',
          bottom: this.width > 340 ? 8 : 0,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 0,
          data: [
            {
              name: "损耗率",
              // icon: "circle",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "使用率",
              // icon: "arrow",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "利用率",
              // icon: "pin",
              textStyle: {
                fontSize: "12px",
              },
            },
          ],
        },
        grid: {
          containLabel: true,
          top: "22%", //距上边距
          bottom: this.width > 340 ? "10%" : "9%", //距离下边距
          right: "5%",
          left: this.width > 340 ? "1%" : "1%",
        },
        xAxis: {
          type: "category",
          data: date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxappreg,
            splitNumber: 5,
            interval: interval_left,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxactive,
            splitNumber: 5,
            interval: interval_right,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
        ],
        series: [
          {
            name: "损耗率",
            type: "line",
            barWidth: 18, //柱图宽度
            data: attrition_rate,
            symbol: "circle",
            yAxisIndex: 0,
          },
          {
            name: "使用率",
            data: usage_rate,
            type: "bar",
            barWidth: this.width > 340 ? 18 : 12, //柱图宽度
            yAxisIndex: 1,
          },
          {
            name: "利用率",
            data: utilization_rate,
            type: "bar",
            barWidth: this.width > 340 ? 18 : 12, //柱图宽度
            yAxisIndex: 1,
          },
        ],
      };
      echart.setOption(option);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
    dateClick(num) {
      this.active = num;
      if (this.active == 1) {
        this.drawChart(this.list.day);
      } else if (this.active == 2) {
        for (let i in this.list.month) {
          this.list.month[i].date = this.list.month[i].date.substring(0, 2);
        }
        this.drawChart(this.list.month);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.income-indicators {
  width: calc(100% - 14px);
  // height: 290px;
  // height: 20%;
  background: url(../../assets/img/Frame_03.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  // bottom:0;
  margin-bottom: 0px;
  padding-left: 14px;
  overflow: hidden;
  .homepage-title {
    width: 70%;
    display: flex;
    left: 23%;
    .title-n {
      color: #fffffd;
      flex-grow: 1;
      z-index: 999;
    }
  }
  .right-btn {
    display: inline-block;
    flex-grow: 1;
    z-index: 999;
    span {
      color: #006EAE;
      cursor: pointer;
    }
    span.active {
      color: #ABE3FE;
    }
  }
  canvas {
    left: 12px !important;
  }
}
@media screen and (max-width: 1500px) {
  .income-indicators {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      // left: 17px;
    }
  }
}
</style>
<style>
.atooltip {
  background:rgba(50,50,50,0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/incomeIndicatorsChart.vue